import React, { useEffect, useRef, useState } from "react";
import Joinus from "../../common/Joinus";
import { accordionItemscontent, initialStates, servicescontent, whatsappMarketingBenefits, whatsappServiceDetails } from "../home/Constant";
import ServiceMetaAni from "./ServiceMetaAni";
import Benefits from "../../common/Benefits";
import { whatsappMarketting } from "../../common/data";
import WhatWeDo from "./WhatWeDo";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel3";
import benefiticon from "../../assets/images/Benefits icon 1 (1).webp"


const ServiceContent = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const itemsToShow = showAll ? accordionItemscontent : accordionItemscontent.slice(0, 10);

  return (
    <div className="margin-topall">
      <section className="py-5 service-position overflow-hidden">
        <div className="container">
          <div className="meta-bg-round">
            {colors.map((color, i) => (
              <div
                key={i}
                id={`dot_00${i}`}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  top: `${initialStates[i].top}px`,
                  left: `${initialStates[i].left}px`,
                  width: `${initialStates[i].width}px`,
                  height: `${initialStates[i].height}px`,
                  marginLeft: `${initialStates[i].marginLeft}px`,
                  opacity: initialStates[i].opacity,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                  willChange: "top, left, width, height, opacity, margin-left",
                }}
              />
            ))}
          </div>
          <div className="pos-z-index ">
            <div className="row justify-content-center"
              data-aos="fade-down" data-aos-delay="300"
            >
              <div className="col-lg-10">
                <div className="">
                  <h5 className="yellow-sub-heading text-center py-2">
                    WhatsApp Marketing
                  </h5>
                  <h4 className="black-service-heading text-center font-align mt-3">
                    Unlock 5x Revenue Growth
                  </h4>
                  <div className="sms-sub-heading">
                    WhatsApp Marketing is a powerful strategy to promote your
                    products <br />
                    and services, driving sales and revenue through targeted{" "}
                    <br />
                    messaging, building brand authenticity, and providing
                    instant
                    <br /> customer support solutions.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* whatwedo */}
      <WhatWeDo data={whatsappServiceDetails} />
      <div className="benefitsfont">benefits</div>
      <div className="benefithead">Whatsapp Marketing</div>
      <div className="mb-5">

        <div className="container-fluid">
          <div className="row">
          

              <div className="col-lg-12">

                <div className="benefitwidth">
                  <OwlCarousel
                    className="owl-theme"
                    loop
                    autoplay={true}
                    items="1"
                    dots={false}
                    smartSpeed={2000}
                    nav={true}
                    navText={[
                      `<i class="fa fa-chevron-left"></i>`,
                      `<i class="fa fa-chevron-right"></i>`,
                    ]}
                    margin={20}
                    // center={true}
                    autoplayTimeout={5000}
                    responsive={{
                      360: {
                        items: "1",
                      },
                      414: {
                        items: "1",
                      },
                      670: {
                        items: "2",
                      },
                      992: {
                        items: "3",
                      },

                      1200: {
                        items: "3",
                      },
                    }}
                  >

                    {whatsappMarketingBenefits.map((item, index) => {
                      return (
                        <div className="position-circle">
                           <img  src={benefiticon} className='benefiticon' alt='icon'/>
                           <div className="border-dot1">
                          <div className="orange-circle">

                          </div>
                          </div>

                          <div className="carousel-wapp-card">

                            <div>
                              <div className="carouselwapp">
                                {item.title}
                              </div>
                              <div className="carousel-para">
                              <ul>
      {item.points.map((point, index) => (
        <li key={index}>{point}</li>
      ))}
    </ul>
                              </div>
                            </div>

                          </div>
                        </div>

                      );
                    })}
                  </OwlCarousel>
                </div>
              </div>
          </div>
        </div>
      </div>
      <Benefits data={whatsappMarketting} />
      <section className="py-5 overflow-hidden">
        <div className="container">
          <div>
            <h1 className="py-2 faqfont mb-5">FAQs - (WhatsApp Marketing)</h1>
          </div>
          <div className="accordion" id="accordionExample">
            {itemsToShow.map((item, index) => (
              <div className="accordion-item border-top" key={index}
                data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`} data-aos-delay="300"
              >
                <h2 className="accordion-header" id={`heading${item.id}`}>
                  <button
                    className={`accordion-button d-flex align-items-center ${index !== 0 ? 'collapsed' : ''
                      }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${item.id}`}
                    aria-expanded={index === 0 ? 'true' : 'false'}
                    aria-controls={`collapse${item.id}`}
                  >
                    <span className="me-3 toggle-icon"></span>
                    {item.question}
                  </button>
                </h2>
                <div
                  id={`collapse${item.id}`}
                  className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                  aria-labelledby={`heading${item.id}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body wrapfaq">{item.answer}</div>
                </div>
              </div>
            ))}
          </div>
          {accordionItemscontent.length > 10 && (
            <div className="text-center py-3 ">
              <button
                className="btn-sm viewbtn"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </div>
      </section>
      <Joinus />
    </div>
  );
};

export default ServiceContent;
